import React from 'react'
import { TouchableOpacity } from 'react-native'
import { StyleService, useStyleSheet } from '@src/style/service'
import { Icon } from '@components/base'

interface AttachmentAddButtonProps {
  accessibilityLabel?: string
  disabled?: boolean
  onPress: () => void
}

export const AttachmentAddButton = ({
  accessibilityLabel = 'Attach file',
  disabled = false,
  onPress,
}: AttachmentAddButtonProps) => {
  const styles = useStyleSheet(themedStyles)

  return (
    <TouchableOpacity
      accessibilityLabel={accessibilityLabel}
      disabled={disabled}
      onPress={onPress}
      style={[styles.button, disabled && styles.disabledButton]}
    >
      <Icon name="plus" size={12} weight="bold" style={styles.icon} />
    </TouchableOpacity>
  )
}

const themedStyles = StyleService.create({
  button: {
    width: 20,
    height: 20,
    borderRadius: 16,
    backgroundColor: 'theme.transparent',
    borderWidth: 2,
    borderColor: 'theme.primary.base',
    alignSelf: 'center',
    alignItems: 'center',
    justifyContent: 'center',
  },
  disabledButton: {
    opacity: 0.4,
  },
  icon: {
    color: 'theme.primary.base',
  },
})
